<template>
  <div>
    <div class="card" v-if="isCard">
      <header class="header-card">
        <p>
          {{ $t('catalogue.audience') }}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-2-fullhd is-4-tablet">
            <b-field
              :label="$t('centreCommercialEmplacement.habitantAirUrbaine')"
              >
              <b-input type="number" :use-html5-validation="false"
                       v-model="entiteCommerciale.nbHabitantsAireUrbaine">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <b-field
              :label="$t('centreCommercialEmplacement.audianceAn')" >
              <b-input v-model="entiteCommerciale.audienceAn"
                       type="number" :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <b-field
              :label="$t('centreCommercialEmplacement.audianceHebdo')" >
              <b-input v-model="entiteCommerciale.audienceHebdo"
                       type="number" :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <b-field
              :label="$t('centreCommercialEmplacement.nbContactAn')" >
              <b-input v-model="entiteCommerciale.nbContactsAn"
                       type="number" :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <b-field
              :label="$t('centreCommercialEmplacement.nbContactHebdo')" >
              <b-input v-model="entiteCommerciale.nbContactsHebdo"
                       type="number" :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet" v-if="produitValue">
            <b-field
              :label="$t('centreCommercialEmplacement.nbRepetition')" >
              <b-input v-model="produitValue.affimetrie.repetition"
                       type="number" :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet" v-if="produitValue">
            <b-field
              :label="$t('centreCommercialEmplacement.pourcentCouverture')"
              >
              <b-input v-model="produitValue.affimetrie.pourcentCouverture"
                       type="number" :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet" v-if="produitValue">
            <b-field
              :label="$t('centreCommercialEmplacement.grp')"
              >
              <b-input v-model="produitValue.affimetrie.grp"
                       type="number" :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <b-field
              :label="$t('centreCommercialEmplacement.localite')"
            >
              <b-input v-model="entiteCommerciale.localite"
                       :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <b-field
              :label="$t('centreCommercialEmplacement.surface')"
            >
              <b-input v-model="entiteCommerciale.surface"
                       type="number" :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <b-field
              :label="$t('centreCommercialEmplacement.revenuNetMenageAn')"
            >
              <b-input v-model="entiteCommerciale.revenuNetMenageAn"
                       type="number" :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-4-tablet">
            <b-field
              :label="$t('centreCommercialEmplacement.indiceCsp')"
            >
              <b-input v-model="entiteCommerciale.indiceCsp"
                       type="number" :use-html5-validation="false">
              </b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline" v-else>
      <div class="column is-3-fullhd is-4-tablet">
        <b-field
          :label="$t('centreCommercialEmplacement.habitantAirUrbaine')">
          <b-input type="number" :use-html5-validation="false"
                   v-model="entiteCommerciale.nbHabitantsAireUrbaine">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <b-field
          :label="$t('centreCommercialEmplacement.audianceAn')">
          <b-input v-model="entiteCommerciale.audienceAn"
                   type="number" :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <b-field
          :label="$t('centreCommercialEmplacement.audianceHebdo')">
          <b-input v-model="entiteCommerciale.audienceHebdo"
                   type="number" :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <b-field
          :label="$t('centreCommercialEmplacement.nbContactAn')">
          <b-input v-model="entiteCommerciale.nbContactsAn"
                   type="number" :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <b-field
          :label="$t('centreCommercialEmplacement.nbContactHebdo')">
          <b-input v-model="entiteCommerciale.nbContactsHebdo"
                   type="number" :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet" v-if="produitValue">
        <b-field
          :label="$t('centreCommercialEmplacement.nbRepetition')" >
          <b-input v-model="produitValue.affimetrie.repetition"
                   type="number" :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet" v-if="produitValue">
        <b-field
          :label="$t('centreCommercialEmplacement.pourcentCouverture')"
          >
          <b-input v-model="produitValue.affimetrie.pourcentCouverture"
                   type="number" :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet" v-if="produitValue">
        <b-field
          :label="$t('centreCommercialEmplacement.grp')"
          >
          <b-input v-model="produitValue.affimetrie.grp"
                   type="number" :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <b-field
          :label="$t('centreCommercialEmplacement.localite')"
        >
          <b-input v-model="entiteCommerciale.localite"
                   :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <b-field
          :label="$t('centreCommercialEmplacement.surface')"
        >
          <b-input v-model="entiteCommerciale.surface"
                   type="number" :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <b-field
          :label="$t('centreCommercialEmplacement.revenuNetMenageAn')"
        >
          <b-input v-model="entiteCommerciale.revenuNetMenageAn"
                   type="number" :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3-fullhd is-4-tablet">
        <b-field
          :label="$t('centreCommercialEmplacement.indiceCsp')"
        >
          <b-input v-model="entiteCommerciale.indiceCsp"
                   type="number" :use-html5-validation="false">
          </b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'm_audience',
  props: {
    entiteCommerciale: {
      type: Object,
      required: true,
    },
    isCard: {
      type: Boolean,
      required: false,
    },
    produitValue: {
      type: Object,
      required: false,
    },
  },
};
</script>

<style scoped>

</style>
